interface SectionSeparatorProps {
  className?: string
}

export const SectionSeparator = ({ className = '' }: SectionSeparatorProps) => {
  return (
    <div
      className={`sm:hidden block py-sm -mx-md w-[calc(100%+2rem)] box-border rotate-180 shadow-sm bg-neutral-surface ${className}`}
    />
  )
}
